var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('div',{staticClass:"MapBox"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.mapId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }